// extracted by mini-css-extract-plugin
module.exports = {"dot":"HotspotDot_dot__m06aj"};